import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getNodesNamesSuffixes = (state: State): any => state.nodesNamesSuffixes;

export const selectNodesNamesSuffixes: MemoizedSelector<
  object,
  string
  > = createSelector(selectBpmnProcessState, getNodesNamesSuffixes);
